export default "__VITE_ASSET__DNeW6DU5__"